import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import mobilePreview from './../configureManage/mobilePreview';
import { INITAL } from '../configureManage/utils';
import { premiumModel, pageModal, buttonModal } from './../configureManage/mobilePreview/components';
export default {
  components: {
    mobilePreview,
    premiumModel,
    pageModal,
    buttonModal
  },
  data() {
    return {
      dialogVisible: false,
      arr: [],
      title: '',
      themeColor: '',
      INITAL,
      pageType: '',
      premiumShow: false,
      configureObj: {},
      pageDescriptionConfig: {},
      pagePopUp: false,
      pagePopUpConfig: {},
      pageModalShow: false,
      buttonModalShow: false,
      buttonPopUpConfig: {},
      buttonModalIndex: -1
    };
  },
  methods: {
    onClickPremium(index) {
      if (index === 0) {
        this.onOpenButtonModal(index, '');
      } else {
        this.premiumShow = false;
      }
    },
    // 打开按钮弹窗
    onOpenButtonModal(index, key, isPremium) {
      var _this$arr$style;
      this.buttonModalIndex = index;
      let item = (_this$arr$style = this.arr[this.arr.length - 1].style) === null || _this$arr$style === void 0 ? void 0 : _this$arr$style.buttonInfo[index];
      if (item.buttonPopUp) {
        this.buttonPopUpConfig = item.buttonPopUpConfig;
        if (key != 'change') {
          this.buttonModalShow = true;
        }
      } else {
        this.buttonModalIndex = -1;
        this.buttonPopUpConfig = {};
      }
    },
    init(val) {
      console.log(val, '---------val----------');
      this.pageType = val.pageType;
      const controlsGroupConfig = JSON.parse(val.controlsGroupConfig);
      console.log(val, controlsGroupConfig, '---------controlsGroupConfig----------');
      let arr = [this.INITAL[val.pageType][0]];
      arr[0].isClick = false;
      arr[0].style = {
        isDisplayNavigation: controlsGroupConfig.isDisplayNavigation,
        titleColor: controlsGroupConfig.isDisplayNavigation,
        backgroundColor: controlsGroupConfig.backgroundColor,
        backgroundImage: controlsGroupConfig.backgroundImage,
        themeColor: controlsGroupConfig.themeColor,
        pageDescription: controlsGroupConfig.pageDescription,
        pageDescriptionConfig: controlsGroupConfig.pageDescriptionConfig,
        pagePopUp: controlsGroupConfig.pagePopUp,
        pagePopUpConfig: controlsGroupConfig.pagePopUpConfig
      };
      this.pageDescription = controlsGroupConfig.pageDescription;
      this.pageDescriptionConfig = controlsGroupConfig.pageDescriptionConfig;
      this.pagePopUp = controlsGroupConfig.pagePopUp;
      this.pagePopUpConfig = controlsGroupConfig.pagePopUpConfig;
      if (this.pagePopUp) {
        this.pageModalShow = true;
      } else {
        this.pageModalShow = false;
      }
      controlsGroupConfig.controlsConfig.map(item => {
        let obj = {
          controlsId: item.controlsId,
          controlsMark: item.controlsMark,
          isClick: false,
          style: item.controlsObject
        };
        arr.push(obj);
      });
      this.arr = arr;
      this.themeColor = this.arr[0].style.themeColor;
      this.configureObj = this.arr[this.arr.length - 1];
      console.log(this.configureObj, 2222);
      this.title = this.$t(val.pageTypeName) + '--' + this.$t('预览');
      this.dialogVisible = true;
    }
  }
};